import { createSlice } from "@reduxjs/toolkit";
import { Currency } from "../../dto/ProfileSettings";

type initialStateInterface = {
  symbol: Currency,
};

const initialState: initialStateInterface = {
  symbol: "JPY",
};

const currencySlice = createSlice({
  name: "settings/currency",
  initialState: initialState,
  reducers: {
    setCurrency: (state, { payload }) => {
      return { symbol: payload };
    }
  }
});

export const { setCurrency } = currencySlice.actions;

export default currencySlice.reducer;
